import styled from "styled-components";

export const Container = styled.div`
  margin: 100px;
  overflow: hidden;

`;

export const ImagesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  grid-row-gap: 30px;
  grid-column-gap: 25px;
  justify-content: center;
`;

export const Image = styled.img`
  width: 300px;
  height: 250px;
`;
